import { c as _c } from "react/compiler-runtime";
import { Container, clx } from "@medusajs/ui";
import Image from "next/image";
import React from "react";
import PlaceholderImage from "@modules/common/icons/placeholder-image";
type ThumbnailProps = {
  thumbnail?: string | null;
  videoUrl?: string | null;
  // TODO: Fix image typings
  images?: any[] | null;
  size?: "small" | "medium" | "large" | "full" | "square";
  isFeatured?: boolean;
  priority?: boolean;
  className?: string;
  "data-testid"?: string;
};
const resolveFirstImageUrl = (images?: any[] | null): string | null => {
  if (!Array.isArray(images)) return null;
  for (const image of images) {
    if (typeof image === "string" && image.trim()) {
      return image.trim();
    }
    if (image && typeof image === "object") {
      const url = typeof image.url === "string" ? image.url.trim() : "";
      if (url) return url;
    }
  }
  return null;
};
const Thumbnail: React.FC<ThumbnailProps> = t0 => {
  const $ = _c(21);
  const {
    thumbnail,
    videoUrl,
    images,
    size: t1,
    isFeatured,
    priority: t2,
    className,
    "data-testid": dataTestid
  } = t0;
  const size = t1 === undefined ? "small" : t1;
  const priority = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== images || $[1] !== thumbnail) {
    t3 = (typeof thumbnail === "string" && thumbnail.trim() ? thumbnail.trim() : null) || resolveFirstImageUrl(images);
    $[0] = images;
    $[1] = thumbnail;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const initialImage = t3;
  const resolvedVideo = !initialImage ? videoUrl ?? undefined : undefined;
  const t4 = !isFeatured && size !== "square";
  const t5 = size === "square";
  const t6 = size === "small";
  const t7 = size === "medium";
  const t8 = size === "large";
  const t9 = size === "full";
  let t10;
  if ($[3] !== className || $[4] !== isFeatured || $[5] !== t4 || $[6] !== t5 || $[7] !== t6 || $[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t10 = clx("relative w-full overflow-hidden p-4 rounded-none shadow-none outline-none", className, {
      "aspect-[11/14]": isFeatured,
      "aspect-[9/16]": t4,
      "aspect-[1/1]": t5,
      "w-[180px]": t6,
      "w-[290px]": t7,
      "w-[440px]": t8,
      "w-full": t9
    });
    $[3] = className;
    $[4] = isFeatured;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = initialImage ?? undefined;
  let t12;
  if ($[12] !== priority || $[13] !== resolvedVideo || $[14] !== size || $[15] !== t11) {
    t12 = <ImageOrPlaceholder image={t11} videoUrl={resolvedVideo} size={size} priority={priority} />;
    $[12] = priority;
    $[13] = resolvedVideo;
    $[14] = size;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== dataTestid || $[18] !== t10 || $[19] !== t12) {
    t13 = <Container className={t10} data-testid={dataTestid}>{t12}</Container>;
    $[17] = dataTestid;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
const ImageOrPlaceholder = t0 => {
  const $ = _c(9);
  const {
    image,
    videoUrl,
    size,
    priority: t1
  } = t0;
  const priority = t1 === undefined ? false : t1;
  if (image) {
    const t2 = priority ? "eager" : "lazy";
    const t3 = priority ? "high" : "auto";
    let t4;
    if ($[0] !== image || $[1] !== priority || $[2] !== t2 || $[3] !== t3) {
      t4 = <Image src={image} alt="Thumbnail" className="absolute inset-0 object-cover object-center rounded-none " draggable={false} quality={50} sizes="(max-width: 576px) 280px, (max-width: 768px) 360px, (max-width: 992px) 480px, 800px" fill={true} priority={priority} loading={t2} fetchPriority={t3} />;
      $[0] = image;
      $[1] = priority;
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  if (videoUrl) {
    let t2;
    if ($[5] !== videoUrl) {
      t2 = <video className="absolute inset-0 h-full w-full object-cover" src={videoUrl} muted={true} playsInline={true} autoPlay={true} loop={true} />;
      $[5] = videoUrl;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  const t2 = size === "small" ? 16 : 24;
  let t3;
  if ($[7] !== t2) {
    t3 = <div className="w-full h-full absolute inset-0 flex items-center justify-center"><PlaceholderImage size={t2} /></div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default Thumbnail;